import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { resolveUrl } from "@/lib/api";

export const BannerCarousel = ({ banners = [] }) => {
  const navigate = useNavigate();
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (banners.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % banners.length), 5000);
    return () => clearInterval(t);
  }, [banners.length]);

  if (!banners.length) return null;

  const go = (d) => setIdx((i) => (i + d + banners.length) % banners.length);
  const open = (b) => { if (b.business_id) navigate(`/activity/${b.business_id}`); else if (b.link) window.open(b.link, "_blank"); };

  return (
    <div className="relative rounded-3xl overflow-hidden h-56 sm:h-72 lg:h-96 group" data-testid="banner-carousel-container">
      {banners.map((b, i) => (
        <div
          key={b.id}
          data-testid="banner-slide-item"
          onClick={() => i === idx && open(b)}
          className={`absolute inset-0 transition-opacity duration-700 ${(b.business_id || b.link) ? "cursor-pointer" : ""}`}
          style={{ opacity: i === idx ? 1 : 0, pointerEvents: i === idx ? "auto" : "none" }}
        >
          <img src={resolveUrl(b.image)} alt={b.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />
          <div className="absolute bottom-0 left-0 p-6 sm:p-10 max-w-2xl">
            <span className="inline-block px-3 py-1 rounded-full bg-accent text-accent-foreground text-xs font-bold uppercase tracking-wider mb-3">
              Προβεβλημένο
            </span>
            <h2 className="font-display text-2xl sm:text-4xl font-extrabold text-white leading-tight drop-shadow">
              {b.title}
            </h2>
          </div>
        </div>
      ))}

      {banners.length > 1 && (
        <>
          <button
            onClick={() => go(-1)}
            data-testid="banner-prev-button"
            className="absolute left-3 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center rounded-full bg-white/90 text-slate-900 opacity-0 group-hover:opacity-100 transition-opacity hover:scale-105"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => go(1)}
            data-testid="banner-next-button"
            className="absolute right-3 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center rounded-full bg-white/90 text-slate-900 opacity-0 group-hover:opacity-100 transition-opacity hover:scale-105"
          >
            <ChevronRight size={20} />
          </button>
          <div className="absolute bottom-4 right-6 flex gap-1.5">
            {banners.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`h-2 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-2 bg-white/50"}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
